<template>
  <div>
    <v-col cols="12" md="12" sm="12" class="date-picker-menu">
      <v-menu
        ref="menu"
        v-model="menu"
        :close-on-content-click="false"
        transition="scale-transition"
        offset-y
        min-width="auto"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            v-model="date"
            :label="label"
            prepend-icon="mdi-calendar"
            readonly
            outlined
            dense
            v-bind="attrs"
            v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker
          class="date-picker"
          v-model="date"
          no-title
          scrollable
          landscape
        >
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="menu = false"> Cancel </v-btn>
          <v-btn text color="primary" @click="saveDate"> OK </v-btn>
        </v-date-picker>
      </v-menu>
    </v-col>
  </div>
</template>

<script>
import dayjs from "dayjs";

let currentDate = dayjs().format("YYYY-MM-DD");
let BeforeWeekDate = dayjs().subtract(7, "day").format("YYYY-MM-DD");

export default {
  name: "datePicker",
  props: {
    label: {
      type: String,
      required: true,
    },
  },

  // computed: {

  //   computedDate() {
  //     let weekBeforDate = dayjs()
  //       .subtract(7, 'day')
  //       .format('YYYY-MM-DD');
  //     return weekBeforDate;
  //   },
  // },

  data: (instance) => ({
    date: instance.label === "From" ? BeforeWeekDate : currentDate,
    menu: false,
  }),

  methods: {
    saveDate() {
      this.$refs.menu.save(this.date);
      this.$emit("setDates", this.date);
    },
  },
};
</script>

<style scoped>
.date-picker-menu {
  z-index: 10 !important;
}
</style>
